// packages/content/src/strings/fish.ts — names are real species; every catch line is original
import type { StringBank } from '../schema/strings';
export default {
  minnow: 'minnow', minnowPun: "A minnow! It's minnow-scule, but it's mine.",
  dace: 'dace', dacePun: 'A dace! An ace catch, if I dace say so myself.',
  perch: 'perch', perchPun: 'A perch! It had nowhere else to sit.',
  rainbowTrout: 'rainbow trout', rainbowTroutPun: 'A rainbow trout! Worth waiting out the drizzle for.',
  salmon: 'salmon', salmonPun: 'A salmon! It swam all this way just to meet me.',
  pike: 'pike', pikePun: 'A pike! Sharp-dressed and sharper-toothed.',
  eel: 'eel', eelPun: "An eel! Slippery customer. Eel be back, I'm sure.",
  bluegill: 'bluegill', bluegillPun: "A bluegill! It looks like it's had a long week.",
  carp: 'carp', carpPun: 'A carp! Carpe diem, as nobody fishing says.',
  koi: 'koi', koiPun: "A koi! Don't be koi, I saw you there.",
  catfish: 'catfish', catfishPun: 'A catfish! Not who it said it was online.',
  anchovy: 'anchovy', anchovyPun: 'An anchovy! Divisive on pizza, delightful on a line.',
  mackerel: 'mackerel', mackerelPun: 'A mackerel! Holy mackerel, as it turns out.',
  flounder: 'flounder', flounderPun: 'A flounder! Floundering is its whole brand.',
  pufferfish: 'pufferfish', pufferfishPun: 'A pufferfish! Easy, big guy. Deep breaths. Out, not in.',
  redSnapper: 'red snapper', redSnapperPun: 'A red snapper! Snappy dresser, too.',
  seaBass: 'sea bass', seaBassPun: "A sea bass! Not the biggest, but it's all about that bass.",
  bluefinTuna: 'bluefin tuna', bluefinTunaPun: "A bluefin tuna! Tuna-mendous. I'll see myself out.",
  oceanSunfish: 'ocean sunfish', oceanSunfishPun: "An ocean sunfish! It's mostly face, and the face is thrilled.",
  whaleShark: 'whale shark', whaleSharkPun: "A whale shark! It's neither, and it doesn't care.",
} as const satisfies StringBank;
